<script>
import Message from "./Message";

const axios = require('axios').default;
import moment from 'moment';

moment().format();

export default {

  name: 'Chat',

  components: {Message},

  mixins: [axios],

  props: {
    route: {
      // endpoint where messages should be sent
      required: true,
      type: String,
    },
    messagesInitial: {
      required: false,
      type: Array,
      default: function () {
        return [];
      }
    },
    user: {
      // will be null if guest user
      required: false,
      type: Object,
      default: function () {
        return null;
      },
    },
    channelId: {
      required: false,
      type: String,
      default: null,
    },
    isAuth: {
      // This is here just to confirm the chat is loaded correctly // TODO:: replace with (bool) user
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      // This is here just to confirm the chat is loaded correctly, can be removed at anypoint
      required: false,
      type: Boolean,
      default: false,
    },
    meta: {
      // meta data to be included with message send
      required: false,
      type: Object,
      default: function () {
        return null;
      },
    },
  },

  data() {
    return {
      message: '',
      messages: [],
      channel: {},
      channelIdCode: null,
    };
  },

  computed: {},

  created() {
    this.messages = this.messagesInitial
    this.setChannelId(this.channelId)
    if (this.channelIdCode) {
      this.listen(this.channelIdCode)
    }

    if (this.route) {
      console.log('OK | Message Post route loaded as: ' + this.route)
    } else {
      console.warn('NOT OK | Route load failed')
    }

    if (this.isAuth) {
      if (this.channelIdCode) {
        console.log('OK | Successfully Loaded Channel ID: ' + this.channelIdCode)
      } else {
        console.warn('NOT OK | Failed to load Channel ID')
        console.warn('Shoundt you be chatting via the Nova chat tool?')
      }

      if (this.user) {
        console.log('OK | Successfully Loaded User: ' + this.user)
      } else {
        console.warn('NOT OK | Failed to load User')
      }

      if (this.messagesInitial) {
        console.log('OK | Messages loaded as:' + this.messagesInitial)
      } else {
        console.warn('NOT OK | Message load failed')
      }
    } else {
      if (this.channelIdCode) {
        console.log('OK | Successfully Loaded Channel ID: ' + this.channelIdCode)
      }

      if (this.user) {
        console.warn('NOT OK | Loaded a User: ' + this.user)
      } else {
        console.log('OK | Successfully Loaded No User')
      }
    }
  },

  methods: {
    listen(channelId) {
      this.channel = window.Echo.channel('messages.' + channelId)
      this.channel.listen('MessageCreated', (e, app) => {
        console.log('This message is ' + (this.isMyMessage(e.message) ? 'NOT' : '') + 'from you')
        if (this.isMyMessage(e.message)) {
          // only add messages not from other chat user
          this.messages.push(e.message)
          this.pling()
        } else {
          // TODO::notify that the message was in fact sent.  "Sent" or "Send Failed"
        }
        setTimeout(() => this.scrollToBottom(), 100);
        this.$emit('ping')
      });
    },
    send() {
      if (this.message.length > 0 && !this.disabled) {
        let data = {
          'content': this.message,
          'is_agent': !!this.user,
          'created_at': moment().format(),
        };
        if (this.channelIdCode) {
          data.channel_id = this.channelIdCode
        }

        data = {
          ...data,
          ...this.meta,
        }

        this.messages.push(data)
        this.message = '';
        axios.post(this.route, data).then((response) => {
          if (!this.channelIdCode) {
            this.setChannelId(response.data.channel_id)
            this.listen(this.channelIdCode)
          }
        }).catch((errors) => {
          console.log('Message did not send')
        });
      }
    },
    formatTime(value) {
      return moment(value).format('LTS')
    },
    scrollToBottom() {
      this.$refs.chatWindow.scrollTop = this.$refs.chatWindow.scrollHeight

      // again just in case
      setTimeout(() => this.$refs.chatWindow.scrollTop = this.$refs.chatWindow.scrollHeight, 100)
    },
    refreshMessages() {
      axios.get('/app/channels/' + this.channelIdCode + '/messages').then((response) => {
        this.messages = response.data
      }).catch((errors) => {
        console.log(errors.response.data.errors)
      });
      this.scrollToBottom()
    },
    setChannelId(channelId) {
      if (!this.channelIdCode) {
        this.channelIdCode = channelId
      }
    },
    isMyMessage(message) {
      return this.isAuth !== message.is_agent;
    },
    pling() {
      let audio = new Audio('/pling.mp3');
      audio.play();
    }
  },
};

</script>

<template>
  <div class="bg-white w-full">
    <div class="flex flex-col flex-auto p-6">
      <div class="flex flex-col flex-auto flex-shrink-0 rounded-lg bg-gray-100 h-full p-4">
        <div class="flex flex-col h-full overflow-x-auto mb-4">
          <div class="flex flex-col h-128 overflow-y-auto" ref="chatWindow">
            <div class="grid grid-cols-12 gap-y-2">
              <Message v-for="message in messages" :username="message.username ? message.username : null"
                       :timestamp="formatTime(message.created_at)"
                       :content="message.content" :local="this.isMyMessage(message)">
              </Message>
            </div>
          </div>
        </div>
        <form @submit.prevent="send" method="post">
          <div class="flex flex-row items-center h-16 rounded-lg bg-white w-full px-4">
            <div class="flex-grow-0">
              <button class="flex items-center justify-center text-gray-400 hover:text-gray-600">
                <svg
                    class="w-5 h-5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                  ></path>
                </svg>
              </button>
            </div>
            <div class="flex-grow">
              <div class="relative w-full">
                <input id="message"
                       v-model="message"
                       type="text"
                       class="flex w-full border focus:outline-none focus:border-indigo-300 pl-4 h-10"
                />
                <button
                    class="absolute flex items-center justify-center h-full w-12 right-0 top-0 text-gray-400 hover:text-gray-600"
                >
                  <svg
                      class="w-6 h-6"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
            <div class="flex-grow-0">
              <button type="submit"
                      class="bg-green-600 hover:bg-green-500 text-white font-bold py-2 px-4 rounded">
                Send
              </button>
            </div>
          </div>
        </form>
        <div>
          <slot name="info"></slot>
        </div>
      </div>
    </div>
  </div>
</template>